<template>
  <div class>
    <div slot="header" class="clearfix" style="background-color: #f2f2f2; padding: 20px">
      <span style="font-weight: 600; color: #000; line-height: 10px">告警设置</span>
    </div>
    <el-form :model="form" :rules="rules" ref="form" label-width="120px" style="width: 400px; margin-top: 20px">
      <el-form-item label="设置名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入设置名称"></el-input>
      </el-form-item>
      <el-form-item label="选择协议" prop="protocolID">
        <el-select v-model="form.protocolID" placeholder="请选择协议" @change="selectChange">
          <el-option
            v-for="item in protocolData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div style="width:1000px;display:flex;padding-top: 20px;" v-for="(_alarm, index) in form.detailList" :key="index">
        <el-card class="box-card" :body-style="{ paddingLeft: '0px',marginTop:'20px', width:'800px'}">
          <el-form-item label="告警项" prop="field">
            <el-select v-model="_alarm.field" placeholder="请选择告警项">
              <el-option
                v-for="item in protocolContent"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="比较模式" prop="compareType">
            <el-select v-model="_alarm.compareType" placeholder="请选择比较模式">
              <el-option key="1" label="过高" value="1"></el-option>
              <el-option key="2" label="过低" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="告警原因" prop="reason">
            <el-row>
              <el-col :span="18">
                <el-input v-model="_alarm.reason" placeholder="请输入告警原因"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="一级告警阈值">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input v-model="_alarm.oneThreshold" placeholder="" @input="change($event, item, index)"></el-input>
                  </el-col>
                  <el-col :span="8">
                    <!-- <div style="margin-left: 10px">℃</div> -->
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="_alarm.oneAlarmNotice" label="是否告警" @change="changeFn1($event,index)"></el-checkbox>
                <el-checkbox v-model="_alarm.oneSmsNotice" label="告警短信" :disabled="isDis1[index].disabled" ></el-checkbox>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="二级告警阈值">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input v-model="_alarm.twoThreshold" placeholder="" @input="change($event, item, index)"></el-input>
                  </el-col>
                  <el-col :span="8">
                    <!-- <div style="margin-left: 10px">℃</div> -->
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="_alarm.twoAlarmNotice" label="是否告警" @change="changeFn2($event,index)"></el-checkbox>
                <el-checkbox v-model="_alarm.twoSmsNotice" label="告警短信" :disabled="isDis2[index].disabled"></el-checkbox>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="三级告警阈值">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input v-model="_alarm.threeThreshold" placeholder="" @input="change($event, item, index)"></el-input>
                  </el-col>
                  <el-col :span="8">
                    <!-- <div style="margin-left: 10px">℃</div> -->
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="_alarm.threeAlarmNotice" label="是否告警" @change="changeFn3($event,index)"></el-checkbox>
                <el-checkbox v-model="_alarm.threeSmsNotice" label="告警短信" :disabled="isDis3[index].disabled"></el-checkbox>
              </el-col>
            </el-row>
          </el-form-item>
        </el-card>
        <div style="line-height: 380px;margin-left: 30px;">
          <i class="el-icon-remove-outline" style="font-size: 45px; color: red;cursor: pointer;" @click="deleteAlarmItem(index)" v-if="form.detailList.length>1"></i>
          <i class="el-icon-circle-plus-outline" style="font-size: 45px; color: rgba(0, 204, 0, 1);margin-left:10px;cursor: pointer;" @click="addAlarmItem" v-if="form.detailList.length-1===index"></i>
        </div>
      </div>
      </el-form>
      <div class="clearfix" style="background-color: #f2f2f2; padding: 20px;margin-top:30px;">
        <span style="font-weight: 600; color: #000; line-height: 10px">设备设置</span>
      </div>
      <el-form :model="form2" :rules="rules2" ref="form2" label-width="120px" style="width: 400px; margin-top: 20px">
      <div class>
        <el-form-item label="选择设备" style="width: 500px" prop="filterText1">
          <el-input placeholder="输入关键字进行过滤" v-model="form2.filterText1"></el-input>
          <el-tree
            class="filter-tree"
            :data="datatree1"
            show-checkbox
            :props="defaultProps"
            default-expand-all
            :filter-node-method="filterNode1"
            ref="tree1"
          >
          </el-tree>
        </el-form-item>
      </div>
    </el-form>

    <div class="btns" style="margin-top: 30px;display: flex;align-items: center;justify-content: center;">
      <el-button @click="cancel" class="resetbtn">取消</el-button>
      <el-button type="success" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request.js";

//import x from ''
export default {
  name: "tongzhiguanli",
  components: {},
  data() {
    return {
      isDis1:[{disabled:true}],
      isDis2:[{disabled:true}],
      isDis3:[{disabled:true}],
      form2:{
        filterText1: "",
      },
      protocolData:[],
      protocolContent:[],
      form: {
        name: "",
        protocolID:"",
        deviceIDs:"",
        detailList: [
          {
            field: "",
            fieldENG:"",
            fieldCHS:"",
            compareType: "",
            reason: "",
            oneThreshold: "",
            oneAlarmNotice: false,
            oneSmsNotice: false,
            twoThreshold: "",
            twoAlarmNotice: false,
            twoSmsNotice: false,
            threeThreshold: "",
            threeAlarmNotice: false,
            threeSmsNotice: false,
          },
        ],
      },
      list:[],
      agreementOption: [],
      datatree1: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      rules: {
        name: [{ required: true, message: "请输入设置名称", trigger: "blur" }],
        protocolID: [{ required: true, message: "请选择协议", trigger: "blur" }],
        // agreement: [{ required: true, message: "请选择协议", trigger: "blur" }]
      },
      rules2: {
        filterText1: [
          { required: true, message: "请选择设备", trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    filterNode1(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    changeFn1($event, index){
      if($event){
        this.isDis1[index].disabled = false
      }else{
        this.form.detailList[index].oneSmsNotice = false
        this.isDis1[index].disabled = true
      }
    },
    changeFn2($event, index){
      if($event){
        this.isDis2[index].disabled = false
      }else{
        this.form.detailList[index].twoSmsNotice = false
        this.isDis2[index].disabled = true
      }
    },
    changeFn3($event, index){
      if($event){
        this.isDis3[index].disabled = false
      }else{
        this.form.detailList[index].threeSmsNotice = false
        this.isDis3[index].disabled = true
      }
    },
    addAlarmItem() {
      let _item = {
        fieldCHS: "",
        fieldENG:"",
        compareType: "",
        reason: "",
        oneThreshold: "",
        oneAlarmNotice: false,
        oneSmsNotice: false,
        twoThreshold: "",
        twoAlarmNotice: false,
        twoSmsNotice: false,
        threeThreshold: "",
        threeAlarmNotice: false,
        threeSmsNotice: false,
      };
      this.isDis1.push({disabled:true})
      this.isDis2.push({disabled:true})
      this.isDis3.push({disabled:true})
      this.form.detailList.push(_item);
    },
    deleteAlarmItem(index) {
      this.form.detailList.splice(index, 1);
    },
    // save() {
    async save() {
      try {
        //必填校验
        await Promise.all([
          this.$refs.form.validate(),
          // this.$refs.form2.validate(),
        ]);
      } catch (error) {
        return;
      }
      console.log(this.$refs.tree1.getCheckedNodes(),3333)
      if(this.$refs.tree1.getCheckedNodes().length < 1){
        this.$notify({
          title: "失败",
          message: "请选择设备",
          type: "warning"
        });
        return
      }else{
        let projectDeviceIds = this.$refs.tree1.getCheckedNodes()
        let tmpDeviceIds = [];
        projectDeviceIds.forEach(element => {
          if(element.parentId != '') {
            tmpDeviceIds.push(element.id)
          }
        });
        for(var j=0;j<this.form.detailList.length;j++){
          for(var i=0;i<this.list.length;i++){
            if(this.form.detailList[j].field == this.list[i].protocolCHS){
              this.form.detailList[j].fieldCHS = this.list[i].protocolCHS
              this.form.detailList[j].fieldENG = this.list[i].protocolENG
              delete this.form.detailList[j].field
            }
          }
        }
        let data = {
          name: this.form.name,
          protocolID: this.form.protocolID,
          deviceIDs: tmpDeviceIds.join(','),
          detailList: this.form.detailList
        };
        console.log(data,'data')
        this.$store.dispatch("form/handle", {
          url: "/battery/dcAlarmSetting/put",
          data: data,
          method: "put",
          callback: (resp) => {
            this.$router.go(-1);
          },
        });
      }
    },
    //获取协议数据
    getProtocolData() {
      this.$store.dispatch("form/handle", {
        url: "/battery/tree/protocol",
        data: {},
        method: "get",
        callback: (resp) => {
          resp.forEach(element => {
            element.label = element.name;
            element.value = element.id;
          });
          this.protocolData = resp;
        },
      });
    },
    //获取设备数据
    getProjectDeviceData(id) {
      let param = {};
      if(id) {
        param.id = id;
      }
      this.$store.dispatch("form/handle", {
        url: "/battery/tree/projectDevice",
        data: param,
        method: "get",
        callback: (resp) => {
          this.datatree1 = resp;
        },
      });
    },
    getProtocolById(id) {
      let param = {
        id: id
      }
      this.$store.dispatch("form/handle", {
        url: "/battery/tree/field",
        data: param,
        method: "get",
        callback: (resp) => {
          this.list = resp
          resp.forEach((item,index)=>{
            let _item = {
              label:item.protocolCHS,
              value:item.protocolCHS
            };
            this.protocolContent.push(_item);
          });
        },
      });
    },
    selectChange(data) {
      this.protocolContent = [];
      for(var i=0;i<this.form.detailList.length;i++){
        this.form.detailList[i].field = ""
      }
      this.getProtocolById(data);
      this.getProjectDeviceData(data);
    }
  },
  mounted() {
    this.getProtocolData();
    this.getProjectDeviceData();
  },
  created() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.btn {
  width: 600px;
  height: 50px;
  margin-top: 10px;
  margin-left: 40%;
}
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color:#00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/alarmSettings/addAlarmSettings.vue